import HTTP from "./http.service";
import Storage from "./storage.service";
import User from "./user.service";
// import Flow from "./flow.service";
import Countries from "./countries.service";
import Helpers from "../helpers/shared.helper";
import Moment from "moment";
import FirebaseAnalytics from "./analytics.service";

var SIM = {};

SIM.getStores = () => {
  let config = {
    method: "get",
    url: "/stores"
  };
  return HTTP(config);
};

SIM.timeWithinRange = (from, to, current) => {
  return from <= current && to > current;
};

SIM.submitDelivery = form => {
  Storage.set("comingFromSIMDelivery", true);
  FirebaseAnalytics.delivery_request();
  let business = JSON.parse(Storage.get("business", true));

  let time_from_int = business.delivery_time_from;
  let time_to_int = business.delivery_time_to;
  time_from_int = parseInt(time_from_int, 10);
  time_to_int = parseInt(time_to_int, 10);

  // if (Settings.get("debug") === true) {
  // 	// To simulate delivery
  // 	if (Storage.get("mock_delivery", true)) {
  // 		User.fetchFlowStatus()
  // 		return
  // 	}
  // }

  SIM.getCurrentTimestamp()
    .then(data => {
      if (data && data.data && data.data.local_date_time) {
        let local_time_string = Moment(
          data.data.local_date_time,
          "DD-MM-YYYY HH:mm:ss"
        );

        let current_time = local_time_string.hours();

        if (
          SIM.timeWithinRange(time_from_int, time_to_int, current_time) &&
          form.address_latlng.value
        ) {
          Helpers.log("time within delivery range, checking ETA..");

          let params =
            "lat=" +
            form.address_latlng.value.lat +
            "&lng=" +
            form.address_latlng.value.lng;

          SIM.getETA(params)
            .then(eta => {
              let code =
                Countries.Countries[form.selected_country.value]["CountryCode"];
              let phone = form.address_phone.value;
              if (phone.slice(0, 1) === "0") {
                phone = phone.substring(1, phone.length);
              }
              let data = {
                number: code + phone,
                lat: form.address_latlng.value.lat,
                lng: form.address_latlng.value.lng,
                customer_name: form.contact_name.value,
                instructions: form.address_instructions.value,
                has_sim: false
              };
              SIM.addDelivery(data)
                .then(response => {
                  
                  if (response.data && response.data.delivery_booking_id) {
                    if (response.data.delivery_booking_id) {
                      let firebase_param = {
                        delivery_time: `${business?.delivery_time_from} to ${business?.delivery_time_to}`,
                      }
                      FirebaseAnalytics.delivery_delivered(firebase_param);
                      // let flags = Storage.get('flags');
                      // driver available
                      // Flow.goTo();
                      Storage.clear("web_delivery_required");
                      Storage.clear("recalled_delivery");
                      Storage.clear("sim_delivered_claim");
                      Storage.clear("delivery_in_progress", true, true);
                      Storage.set(
                        "delivery_booking_id",
                        response.data.delivery_booking_id,
                        true
                      );
                      Storage.set("deliverInprogress", true, true);
                      User.fetchFlowStatus(100);
                    } else {
                      // no driver
                      throw new Error("error_delivery_unavailable");
                      // Errors.handleError("error_delivery_unavailable");
                    }
                  } else {
                    
                    throw new Error("error_delivery_unavailable");
                    // Errors.handleError("error_delivery_unavailable");
                  }

                  // SIM.getDeliveryStatus().then(resp => {
                  //
                  // }).catch(err => {

                  // });
                })
                .catch(error => { 
                  
                });

              // driver available
              // Storage.set("delivery_status", "delivery_success");
              // Storage.set("error", "delivery_success");
            })
            .catch(error => {
              
              Helpers.log("ETA error, proceeding to /unsupported-location");
              form.reset();
            });
        } else {
          
          Helpers.log("time outside range, proceeding to unavailable delivery");
          form.reset();

          throw new Error("error_delivery_unavailable");
        }
      } else {
        
        Helpers.log("error getting time, proceeding to unavailable delivery");
        form.reset();
        throw new Error("error_delivery_unavailable");
      }
    })
    .catch(error => {
      
      Helpers.log(
        "error getting current time, proceeding to unavailable delivery"
      );
      form.reset();
      // throw new Error("error_delivery_unavailable")
    });
};

SIM.addDelivery = data => {
  let config = {
    method: "post",
    url: "/deliveries",
    data: data
  };
  return HTTP(config);
};

SIM.cancelDelivery = data => {
  let config = {
    method: "delete",
    url: `/deliveries?delivery_id=${data}`,
    data: data
  };
  return HTTP(config);
};

SIM.getETA = params => {
  let config = {
    method: "get",
    url: "/deliveries/eta?" + params
  };
  return HTTP(config);
};

SIM.getDeliveryStatus = () => {
  let config = {
    method: "get",
    url: "deliveries/tracking"
  };
  return HTTP(config);
};

SIM.getCurrentTimestamp = () => {
  let config = {
    method: "get",
    url: "/me/current_timestamp",
    headers: {
      "virgin-api-version": "v1",
      "virgin-device-os": "web",
      "cache-control": "no-cache"
    }
  };
  return HTTP(config);
};

SIM.getDeactivationReasons = () => {
  let config = {
    method: "get",
    url: "/deactivation/reasons",
    headers: {
      "virgin-api-version": "v1",
      "virgin-device-os": "web",
      "cache-control": "no-cache",
      "Session-Id": Storage.get("session")
    }
  };
  return HTTP(config);
}

/**
 * Verify ID and Number assocaition API
 * @param {*} data
 * @returns
 */
SIM.verifyIdAndNumberAssociation = data => {
  let config = {
    method: "post",
    url: "/deactivation/request_otp_for_web",
    headers: {
      "virgin-api-version": "v1",
      "virgin-device-os": "web",
      "cache-control": "no-cache",
      "Session-Id": Storage.get("session")
    },
    data: data
  };
  return HTTP(config);
}

/**
 * Deactivation Confirmation
 * @param {*} data
 * @returns
 */
SIM.confirmDeactivation = data => {
  let config = {
    method: "post",
    url: "/deactivation/confirm",
    headers: {
      "virgin-api-version": "v1",
      "virgin-device-os": "web",
      "cache-control": "no-cache",
      "Session-Id": Storage.get("session")
    },
    data: data
  };
  return HTTP(config);
}


SIM.kitCode = (data) => {
  let config = {
    method: "post",
    url: "/activation/sim",
    data: data,
  };
  return HTTP(config);
};

SIM.getESIMUrl = () => {
  let config = {
    method: "get",
    url: "/customer/numbers",
  };
  return HTTP(config);
};

export default SIM;